import styled from 'styled-components';
const MenuItemStyle = styled.li `
  user-select: none;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export default MenuItemStyle;
//# sourceMappingURL=MenuItemStyle.js.map